// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32d3db89","239":"c95e7f66","453":"6ba60391","732":"6f78b0b6"}[chunkId] + ".chunk.js";
};